import { useState } from "react";
import { Button } from "@/components/ui/button";
import { FeedbackDialog } from "@/components/dashboard/FeedbackDialog";
import {
  useSidebar,
  SidebarGroup,
  SidebarGroupContent,
} from "@/components/ui/sidebar";
import { AnimatedShinyText } from "@/components/ui/animated-shiny-text";

export function NavFeedback() {
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const { state } = useSidebar();

  if (state === "collapsed") {
    return (
      <div className="flex flex-col gap-2">
        <FeedbackDialog open={feedbackOpen} onOpenChange={setFeedbackOpen} />
      </div>
    );
  }

  return (
    <SidebarGroup className="mt-auto px-2 py-0">
      <SidebarGroupContent>
        <div className="relative p-4 rounded-xl bg-card/60 dark:bg-white/5 backdrop-blur-3xl border border-border/60 shadow-sm flex flex-col gap-3 group transition-all hover:border-border/80 overflow-hidden hover:shadow-md">
          {/* <div className="absolute inset-0 bg-linear-to-r from-primary/0 via-primary/5 to-primary/0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000 rounded-xl" /> */}
          <div className="space-y-1.5 relative z-10 w-full">
            <h4 className="flex items-start gap-1.5 text-sm font-bold  w-[200px]">
              <AnimatedShinyText className="inline-flex items-start justify-start font-bold px-0 cursor-default text-black dark:text-white mx-0">
                <span>Earn free credits</span>
              </AnimatedShinyText>
            </h4>
            <p className="text-xs text-muted-foreground leading-relaxed w-[200px]">
              Unlock free Rayloop credits by reporting bugs and requesting
              features.
            </p>
          </div>
          <Button
            onClick={() => setFeedbackOpen(true)}
            className="w-full relative z-10 bg-foreground hover:bg-foreground/90 text-background font-semibold shadow-none h-9 mt-1 cursor-pointer transition-all hover:shadow-md active:scale-95"
          >
            Send Feedback
          </Button>
        </div>

        <FeedbackDialog open={feedbackOpen} onOpenChange={setFeedbackOpen} />
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
